// extracted by mini-css-extract-plugin
module.exports = {"root":"icons_root__oWa1L","searchPage":"icons_searchPage__WsvKk"};